import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';

export const ShellPage = () => {
  return (
    <Layout style={{ padding: '0 24px' }}>
      <Outlet />
    </Layout>
  );
};
